var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const YIELD_AFTER_MS = 9;
const vXMLSerializer = new XMLSerializer();
function makeImage(uri, cachedImage) {
    return __awaiter(this, void 0, void 0, function* () {
        return yield new Promise((resolve, reject) => {
            const image = cachedImage !== null && cachedImage !== void 0 ? cachedImage : new Image();
            image.decoding = "async";
            image.onerror = () => {
                reject(`Failed to create image for '${uri}'`);
            };
            image.src = uri;
            if ("decode" in image) {
                // decode should not affect the execution on the main thread
                image
                    .decode()
                    .then(() => {
                    resolve(image);
                })
                    .catch((error) => {
                    reject(error);
                });
            }
            else {
                ;
                image.onload = () => {
                    resolve(image);
                };
            }
        });
    });
}
function isDataUrl(url) {
    return url.search(/^(data:)/) !== -1;
}
const mimes = (function () {
    /*
     * Only WOFF and EOT mime types for fonts are 'real'
     * see http://www.iana.org/assignments/media-types/media-types.xhtml
     */
    const WOFF = "application/font-woff";
    const JPEG = "image/jpeg";
    return {
        woff: WOFF,
        woff2: WOFF,
        ttf: "application/font-truetype",
        eot: "application/vnd.ms-fontobject",
        png: "image/png",
        jpg: JPEG,
        jpeg: JPEG,
        gif: "image/gif",
        tiff: "image/tiff",
        svg: "image/svg+xml"
    };
})();
function parseExtension(url) {
    const match = /\.([^\.\/]*?)$/g.exec(url);
    return match ? match[1] : "";
}
function mimeType(url) {
    const extension = parseExtension(url).toLowerCase();
    return mimes[extension] || "";
}
function escapeXhtml(xhtml) {
    return xhtml.replace(/#/g, "%23").replace(/\n/g, "%0A");
    // return encodeURIComponent(xhtml);
}
function timeout(o) {
    return __awaiter(this, void 0, void 0, function* () {
        return yield new Promise((resolve) => {
            setTimeout(() => {
                resolve(o);
            }, 0);
        });
    });
}
class MyDomToImage {
    constructor() {
        this.headCash = new WeakMap();
        this.headMutationObservers = new WeakMap();
        this.imageCash = new Map();
        this.stylesheetCash = new Map();
    }
    toSvg(element, options) {
        return __awaiter(this, void 0, void 0, function* () {
            var _a;
            options = options || {};
            const head = element.ownerDocument.head;
            const w = element.ownerDocument.defaultView;
            const timerHeadRef = {
                lastTimeoutTime: performance.now()
            };
            let serializedHead = this.headCash.get(head);
            if (!serializedHead) {
                const node = yield this.cloneNodeYield(head, timerHeadRef, (node) => {
                    return !(node instanceof w.HTMLStyleElement ||
                        node.nodeType == Node.TEXT_NODE ||
                        (node instanceof w.HTMLLinkElement && node.rel.toLowerCase() === "stylesheet"));
                });
                serializedHead = this.buildString(node, timerHeadRef);
                if (!this.headMutationObservers.has(head)) {
                    const mutationObsever = new MutationObserver(() => {
                        this.headCash.delete(head);
                    });
                    mutationObsever.observe(head, {
                        attributes: true,
                        childList: true,
                        subtree: true
                    });
                    this.headMutationObservers.set(head, mutationObsever);
                }
                this.headCash.set(head, serializedHead);
            }
            const timerBodyRef = {
                lastTimeoutTime: performance.now()
            };
            const serializedElement = this.cloneNodeYield(element, timerBodyRef)
                .then((node) => vXMLSerializer.serializeToString(node))
                .then(timeout)
                .then((xhtml) => escapeXhtml(xhtml));
            // CSS layout dimensions — the SVG coordinate space uses these so HTML lays out
            // at exactly the element's natural CSS size (no foreignObject scaling surprises).
            const cssWidth = options.width || element.clientWidth;
            const cssHeight = options.height || element.clientHeight;
            // Output pixel dimensions — dpr× larger so the resulting image is HiDPI sharp.
            const pixelRatio = window.devicePixelRatio * ((_a = options.resolutionScale) !== null && _a !== void 0 ? _a : 1);
            const pxWidth = cssWidth * pixelRatio;
            const pxHeight = cssHeight * pixelRatio;
            const bgColor = options.bgColor || "white";
            return yield Promise.all([serializedHead, serializedElement])
                .then(([head, body]) => `<html xmlns="http://www.w3.org/1999/xhtml">${head}${body}</html>`)
                .then((xhtml) => `<foreignObject x="0" y="0" width="100%" height="100%">${xhtml}</foreignObject>`)
                .then((foreignObject) => 
            // viewBox maps SVG coordinate units to CSS pixels so content fills the canvas exactly.
            // width/height control the output pixel count (HiDPI = dpr× more pixels).
            `<svg xmlns="http://www.w3.org/2000/svg" width="${pxWidth}" height="${pxHeight}" viewBox="0 0 ${cssWidth} ${cssHeight}" style="background-color:${bgColor}">${foreignObject}</svg>`)
                .then((svg) => `data:image/svg+xml;charset=utf-8,${svg}`);
        });
    }
    buildString(node, timerRef) {
        return __awaiter(this, void 0, void 0, function* () {
            const children = node.childNodes;
            const nodeName = node.nodeName;
            const endTag = `</${nodeName}>`;
            let xhtml = `<${nodeName}>`;
            if (children.length === 0)
                return yield Promise.resolve(xhtml + endTag);
            for (let i = 0, l = children.length; i < l; ++i) {
                const child = children[i];
                const str = vXMLSerializer.serializeToString(child);
                xhtml += escapeXhtml(str);
                if (performance.now() - timerRef.lastTimeoutTime >= YIELD_AFTER_MS) {
                    yield timeout();
                    timerRef.lastTimeoutTime = performance.now();
                }
            }
            xhtml += endTag;
            return yield Promise.resolve(xhtml);
        });
    }
    toImage(element, image, options) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.toSvg(element, options)
                .then(timeout)
                .then((url) => __awaiter(this, void 0, void 0, function* () { return yield makeImage(url, image); }))
                .then(timeout);
        });
    }
    cloneNodeYield(node, timerRef, filter) {
        return __awaiter(this, void 0, void 0, function* () {
            const w = node.ownerDocument.defaultView;
            if (node instanceof w.HTMLIFrameElement) {
                try {
                    // if the node is an iframe clone the documentElement of
                    // the iframe instead of the iframe itself
                    node = node.contentWindow.document.documentElement;
                }
                catch (error) {
                    const div = document.createElement("div");
                    div.appendChild(document.createTextNode(error.toString()));
                    return yield Promise.resolve(div);
                }
            }
            return yield this.makeNodeCopy(node)
                .then((clone) => __awaiter(this, void 0, void 0, function* () { return yield this.cloneChildrenYield(node, clone, timerRef, filter); }))
                .then((clone) => __awaiter(this, void 0, void 0, function* () { return yield this.processClone(node, clone); }));
        });
    }
    cloneChildrenYield(original, clone, timerRef, filter) {
        return __awaiter(this, void 0, void 0, function* () {
            const children = original.childNodes;
            if (children.length === 0)
                return yield Promise.resolve(clone);
            let done = Promise.resolve();
            for (let i = 0, l = children.length; i < l; ++i) {
                const child = children[i];
                if (child.nodeType === Node.COMMENT_NODE)
                    continue;
                if (filter && filter(child))
                    continue;
                done = done.then(() => __awaiter(this, void 0, void 0, function* () { return yield this.cloneNodeYield(child, timerRef); })).then((childClone) => clone.appendChild(childClone));
                if (performance.now() - timerRef.lastTimeoutTime >= YIELD_AFTER_MS) {
                    yield timeout();
                    timerRef.lastTimeoutTime = performance.now();
                }
            }
            return yield done.then(() => clone);
        });
    }
    makeNodeCopy(node) {
        return __awaiter(this, void 0, void 0, function* () {
            const w = node.ownerDocument.defaultView;
            if (node instanceof w.HTMLCanvasElement) {
                return yield makeImage(node.toDataURL());
            }
            if (node instanceof w.HTMLLinkElement && node.rel.toLowerCase() === "stylesheet") {
                return yield this.makeStyle(node);
            }
            return yield Promise.resolve(node.cloneNode(false));
        });
    }
    makeStyle(link) {
        return __awaiter(this, void 0, void 0, function* () {
            let css = this.stylesheetCash.get(link.href);
            if (!css) {
                css = this.get(link.href).then((response) => response.text());
                this.stylesheetCash.set(link.href, css);
            }
            return yield css.then((css) => {
                const style = document.createElement("style");
                style.innerHTML = css;
                return style;
            });
        });
    }
    processClone(original, clone) {
        return __awaiter(this, void 0, void 0, function* () {
            const w = original.ownerDocument.defaultView;
            if (!(clone instanceof w.Element))
                return clone;
            if (clone instanceof w.HTMLElement && clone.hasAttribute("data-links")) {
                // The "data-links"-Attribute is used by Looker to store information on
                // how to query the date for a Dashboard element. We don't need this
                // information to correctly render a dashboard-element and they may
                // include Symbols that cause the rendering to fail.
                // Therefore it's best to delete the "data-links"-Attribute.
                clone.setAttribute("data-links", "");
            }
            if (clone instanceof w.HTMLAnchorElement) {
                // We don't need the href to correctly render an element, but it may
                // include Symbols that cause the rendering to fail.
                clone.href = "";
            }
            if (clone instanceof w.HTMLTextAreaElement) {
                clone.innerHTML = original.value;
            }
            if (clone instanceof w.HTMLInputElement) {
                clone.setAttribute("value", original.value);
            }
            if (clone instanceof w.SVGElement) {
                this.fixSvg(clone, w);
            }
            if (clone instanceof w.HTMLImageElement) {
                return yield this.inlineImage(clone);
            }
            return clone;
        });
    }
    fixSvg(clone, w) {
        clone.setAttribute("xmlns", "http://www.w3.org/2000/svg");
        if (clone instanceof w.SVGRectElement) {
            const width = clone.getAttribute("width");
            if (width)
                clone.style.setProperty("width", width);
            const height = clone.getAttribute("height");
            if (height)
                clone.style.setProperty("height", height);
        }
    }
    inlineImage(img) {
        return __awaiter(this, void 0, void 0, function* () {
            if (isDataUrl(img.src)) {
                return yield Promise.resolve(img);
            }
            let dataUrl = this.imageCash.get(img.src);
            if (!dataUrl) {
                dataUrl = this.getAndEncode(img.src).then((data) => `data:${mimeType(img.src)};base64,${data}`);
                this.imageCash.set(img.src, dataUrl);
            }
            return yield dataUrl.then((dataUrl) => __awaiter(this, void 0, void 0, function* () {
                return yield new Promise(function (resolve, reject) {
                    img.onload = () => {
                        resolve(img);
                    };
                    img.onerror = reject;
                    img.src = dataUrl;
                });
            }));
        });
    }
    get(url) {
        return __awaiter(this, void 0, void 0, function* () {
            const TIMEOUT = 30000;
            return yield new Promise((resolve, reject) => {
                const request = new XMLHttpRequest();
                request.onreadystatechange = () => {
                    if (request.readyState !== 4)
                        return;
                    if (request.status !== 200) {
                        reject(`cannot fetch resource: ${url}, status: ${request.status}`);
                        return;
                    }
                    resolve(request.response);
                };
                request.ontimeout = () => {
                    reject(`timeout of ${TIMEOUT}ms occured while fetching resource: ${url}`);
                };
                request.responseType = "blob";
                request.timeout = TIMEOUT;
                request.open("GET", url, true);
                request.send();
            });
        });
    }
    getAndEncode(url) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.get(url).then((response) => __awaiter(this, void 0, void 0, function* () {
                return yield new Promise((resolve) => {
                    const encoder = new FileReader();
                    encoder.onloadend = () => {
                        const content = encoder.result.split(/,/)[1];
                        resolve(content);
                    };
                    encoder.readAsDataURL(response);
                });
            }));
        });
    }
}
export const myDomToImage = new MyDomToImage();
